import React from "react";
import { useNavigate } from "react-router-dom";

const ReturnPage = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    // You might fetch the signing status here if needed
    alert("Thank you for completing the signing!");
    navigate("/employee/forms"); // Redirect back to forms page
  }, [navigate]);

  return <div>Redirecting...</div>;
};

export default ReturnPage;